<template>
  <div class="list-detail" :id="uuid">
    <button type="button" class="list-detail-back" @click="showGrid">
      <IconBack />
      Back to Quick Move-Ins
    </button>
    <div class="list-detail-inner" :id="`list-detail_${quickMoveIn.slug}`">
      <div class="list-detail-header">
        <h3 class="list-detail-header-title">{{ quickMoveIn.title }}</h3>
      </div>
      <div class="list-detail-image slick-loading">
        <div class="list-detail-slider" :id="`list-slider-${quickMoveIn.id}`">
          <div
            class="list-detail-image-slide"
            v-for="(slide, i) in quickMoveIn.slide_images"
            :key="`list-detail-slider-slide-${i}`"
          >
            <img :src="slide.url" :alt="slide.title" />
          </div>
        </div>
        <div class="list-detail-slider-controls">
          <button type="button" class="arrow-prev" :id="`arrow-prev-${quickMoveIn.id}`">
            <IconTriangleLeft />
          </button>
          <button type="button" class="arrow-next" :id="`arrow-next-${quickMoveIn.id}`">
            <IconTriangleRight />
          </button>
        </div>
      </div>
      <div class="list-detail-meta">
        <div class="list-detail-meta-cost">
          Starting at
          <div class="list-detail-meta-cost-num">{{ startingAt(quickMoveIn.price) }}</div>
        </div>
        <div class="list-detail-meta-block">
          <div class="list-detail-meta-block-icon">
            <IconBeds />
          </div>
          {{ beds || '-' }} beds
        </div>
        <div class="list-detail-meta-block">
          <div class="list-detail-meta-block-icon">
            <IconBaths />
          </div>
          {{ baths || '-' }} baths
        </div>
        <div class="list-detail-meta-block">
          <div class="list-detail-meta-block-icon">
            <IconSqFeet />
          </div>
          {{ quickMoveIn.sq_ft || '-' }} sqft
        </div>
      </div>
      <div class="list-detail-categories">
        <div class="list-detail-category">Property Type</div>
        <div class="list-detail-category-text">{{ quickMoveIn.property_type }}</div>
        <div class="list-detail-category">Location</div>
        <div class="list-detail-category-text">{{ quickMoveIn.location }}</div>
        <div class="list-detail-category">School District</div>
        <div class="list-detail-category-text">{{ quickMoveIn.school_district }}</div>
      </div>
      <a :href="quickMoveIn.link" class="btn btn-full btn-dark">View Home</a>
      <div class="list-detail-more">
        <div v-if="quickMoveIn.style && quickMoveIn.style !== 'Custom'" class="list-detail-half">
          <div class="list-detail-more-label">Style</div>
          <ul>
            <li>{{ quickMoveIn.style || '-' }}</li>
          </ul>
        </div>
        <div v-if="quickMoveIn.distance_to && !quickMoveIn.community_area.includes('philadelphia')" class="list-detail-half">
          <div class="list-detail-more-label">Distance to Pittsburgh</div>
          <ul>
            <li>{{ quickMoveIn.distance_to || '-' }} miles</li>
          </ul>
        </div>

        <div v-if="quickMoveIn.special_features.length" class="list-detail-full">
          <div class="list-detail-more-label">Special Features</div>
          <ul>
            <li v-for="(feature, i) in quickMoveIn.special_features" :key="`special-features-${i}`">
              {{ feature.feature }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import IconBack from '@/components/icons/IconBack';
import IconBaths from '@/components/icons/IconBaths';
import IconBeds from '@/components/icons/IconBeds';
import IconSqFeet from '@/components/icons/IconSqFeet';
import IconTriangleLeft from '@/components/icons/IconTriangleLeft';
import IconTriangleRight from '@/components/icons/IconTriangleRight';
import hasSlickSlider from '@/mixins/hasSlickSlider';
import { uuidv4 } from '@/helpers/ui';

export default {
  name: 'QuickMoveInListDetail',
  components: { IconBack, IconBaths, IconBeds, IconSqFeet, IconTriangleLeft, IconTriangleRight },
  mixins: [hasSlickSlider],
  data() {
    return {
      sliderClass: '.list-detail-slider',
    };
  },
  computed: {
    baths() {
      if (!this.quickMoveIn.baths) {
        return '?';
      }

      if (this.quickMoveIn.baths_min) {
        if (this.quickMoveIn.baths_min > this.quickMoveIn.baths) {
          return `${this.quickMoveIn.baths_min}+`;
        }

        return `${this.quickMoveIn.baths_min} - ${this.quickMoveIn.baths}`;
      }

      return this.quickMoveIn.baths;
    },
    beds() {
      if (!this.quickMoveIn.beds) {
        return '?';
      }

      if (this.quickMoveIn.beds_min) {
        if (this.quickMoveIn.beds_min > this.quickMoveIn.beds) {
          return `${this.quickMoveIn.beds_min}+`;
        }

        return `${this.quickMoveIn.beds_min} - ${this.quickMoveIn.beds}`;
      }

      return this.quickMoveIn.beds;
    },
    quickMoveIn() {
      return this.$store.getters['ui/getDetailedQuickMoveIn'];
    },
    uuid() {
      return uuidv4();
    },
  },
  watch: {
    quickMoveIn: function(newValue, oldValue) {
      // console.log('QuickMoveInListDetail watch quickMoveIn', newValue, oldValue);
      if (oldValue !== false) {
        this.sliderUpdatePending = true;
      }
    },
  },
  methods: {
    showGrid() {
      this.$store.dispatch('ui/setPanelView', { quickMoveIn: false, panelView: 'grid' });
    },
    startingAt(price) {
      const thePrice = Number(price.replaceAll(',', ''));
      if (thePrice > 0) {
        const formattedAmount = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          maximumFractionDigits: 0  // Ensures at most two decimal places
        }).format(thePrice);

        return formattedAmount;
      } else {
        return 'Contact Us';
      }
    },
  },
};
</script>
